export enum LayoutType {
  BALANCE = 2,
  LEFT = 1,
  RIGHT = 0,
  // Vertical layouts mirror the horizontal trio:
  //   TOP    — root on top, children grow downward   (mirrors RIGHT)
  //   BOTTOM — root at the bottom, children grow up  (mirrors LEFT)
  //   BALANCE_VERTICAL — children split above/below  (mirrors BALANCE)
  TOP = 3,
  BOTTOM = 4,
  BALANCE_VERTICAL = 5,
}

export enum MindmapStyle {
  FOUR = 4,
  ONE = 1,
  THREE = 3,
  TWO = 2,
}
